<template>
    <tr>
        <td>
            {{ payment.paymentMethod.shortName }}
            <br />
            <small>{{ dateFilter(payment.takenAt, true) }}</small>
        </td>
        <td>{{ currencyFilter(payment.amount) }}</td>
        <td>
            <PaymentStatusLabel :payment="payment" />

            <span v-if="isSaved"
                  class="label label-success">
                {{ l('PAYMENT_ERROR.PAYMENT_SAVED') }}
            </span>
            <span v-else
                  class="label label-danger">
                {{ l('PAYMENT_ERROR.PAYMENT_NOT_SAVED') }}
            </span>
        </td>
    </tr>
</template>

<script>
import PaymentStatusLabel from '@/vue/components/Badges/PaymentStatusLabel';

export default {
    components: { PaymentStatusLabel },

    props: {
        /**
         * @type {Payment}
         */
        payment: {
            type: Object,
            required: true,
        },

        isSaved: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
